import { MdcDialog } from '@angular-mdc/web';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ContentService } from 'src/app/content.service';
import { BekreftZrapportComponent } from '../dialogs/bekreft-zrapport/bekreft-zrapport.component';
import { XzrapportComponent } from '../dialogs/xzrapport/xzrapport.component';

@Component({
  selector: 'app-kasse-start-stopp',
  templateUrl: './kasse-start-stopp.component.html',
  styleUrls: ['./kasse-start-stopp.component.scss']
})
export class KasseStartStoppComponent implements OnInit {

  @Input() public kassedata;
  @Input() public admin;

  @Output() public startet = new EventEmitter<boolean>();
  @Output() public stoppet = new EventEmitter<boolean>();

  public kasse;
  public kassasum = new FormControl();
  public avdelinger;
  public avdeling = new FormControl();

  constructor(
    private contentService: ContentService,
    private dialog: MdcDialog
  ) { }

  ngOnInit() {
    this.contentService.fetchContent('/avdeling').subscribe(res => {
      this.avdelinger = res;
      if (this.admin) {
        let avd = this.avdelinger.find(avd => avd.navn === "Adminstrasjonen");
        this.avdeling.setValue(avd.id);
      }
    })
  }

  ngOnChanges(): void {
    this.fetchData();
  }

  fetchData() {
    this.kasse = this.kassedata.kasse;
    if (this.kasse.aapen) {
      this.avdeling.setValue(this.kassedata.avdeling.id);
      this.avdeling.disable();
      this.kassasum.setValue(this.kasse.belop);
      this.kassasum.disable();
    } else {
      this.kassasum.setValue(this.kassedata['siste_z_rapp']['belop_opptalt']);
      this.kassasum.enable();
      this.avdeling.enable();
    }
  }

  startSale() {
    // do request to server
    this.contentService.postContent('/salg/kasse/start', {
      belop: this.kassasum.value,
      avdeling_id: this.avdeling.value.toString()
    }).subscribe(kasse => {
      this.kasse = kasse;
      this.kassasum.disable();
      this.avdeling.disable();
      this.contentService.updateKasseState({kasse: this.kasse});
    })
    this.startet.emit(true);
  }

  confirmEndDay() {
    this.dialog.open(BekreftZrapportComponent).afterClosed()
      .subscribe(res => {
        if (res.accept === true) {
          if(res.belop_opptalt != null) {
            this.endDay(res.belop_opptalt, res.diff_kommentar, res.fribillett_utdelt, res.fribillett_begrunnelse);
          }
          else {
            alert ('Opptalt kassebeholdning er ikke oppgitt, kan ikke lukke kassa');
          }
        }
      });
  }

  canEndDay() {
    if (this.admin) {
      return true;
    }
    else {
      return false; // TODO
    }
    
  }

  endDay(belop_opptalt, diff_kommentar, fribillett_utdelt?, fribillett_begrunnelse?) {
    this.dialog.open( XzrapportComponent, {data: {type: 'z', belop_opptalt, diff_kommentar, fribillett_utdelt, fribillett_begrunnelse}} )
      .afterClosed().subscribe( closed => {
        this.stoppet.emit(true);
        this.fetchData();
      } );
  }

}
